// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '5d4f9cd2dcd37988df71e3f9706ef3aec25d9b19';
export const BUILD_NUMBER = '210';
export const BUILD_TIMESTAMP = '2026-07-27T23:42:52.138Z';
